/**
 * @copyright 2019 @ DigiNet
 * @author kimlong
 * @create 2019/01/11 10:37
 * @update 2019/01/11 10:37
 * @file src/components/common/print/print.js
 */

import React from 'react';
import { connect } from "react-redux";
import DropDownReportTemplate from "../../common/dropdown/template/dropdown-report-template";
import FileViewer from "../../common/fileviewer/fileviewer";
import Config from "../../../config";
import PropTypes from 'prop-types';
import {TextBox} from "devextreme-react";
import Button from "../../common/button/button";
import { Row, Col, Modal, ModalHeader, ModalBody, Button as ButtonCore, Label } from 'diginet-core-ui/components';
import * as W17f2040Actions from "../../../actions/w17/w17F2040/w17f2040-actions";
import { Loading } from "../../common/loading/loadingCore";
class Print extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            reportID: '',
            reportName: '',
            url: '',
            urlPreview: '',
            fileExt: '',
            report: null,
            openFileView: false,
            IsSBJCRM: null,
            loading: false,
            fileViewerData: {
                reportName: '',
                urlPreview: '',
                fileExt: ''
            }
        };
        this.passParam = false;
    }
    
    componentDidMount() {
        if (this.props.ref) this.props.ref(this);
        this.loadCustomer();
    }

    loadCustomer = () => {
        this.props.dispatch(
            W17f2040Actions.loadCustomer((error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if(data) {
                this.setState({ IsSBJCRM: data?.IsSBJCRM})
            }
        })
        );
    };

    onHide() {
        const {onHide} = this.props;
        if (onHide) {
            onHide(this.isSaved && this.state);
        }
    }

    printReport(mode, isPreview = false) {
        const param = [...this.props.param];
        const { beforePreviewTemplate, onExportExcel, isViewPDF } = this.props; 
        const {report, url, reportID, reportName, reportTypeID, fileExt} = this.state;
        param.push({type: "Varchar", id: "ReportID", value: reportID});
        if (Config.isEmpty(mode) && fileExt === 'pdf') mode = 1;
        const isPreViewPdfOnly = isPreview && isViewPDF;
        const previewType = isViewPDF ? 'pdf' : '';
        const options = {
            reportURL: url,
            reportID: reportID,
            reportName: reportName,
            reportTypeID: reportTypeID,
            isPDF: mode === 1 ? 1 : 0,
            exportType: mode === 1 || isPreViewPdfOnly ? "pdf" : (report?.FileExt ? report?.FileExt.replace('.', '') : ""),
            strSQL: report?.StrSQL ? report?.StrSQL : "",
            fileExt
        };
        if (isPreview) {
            this.setState({ loading: true });
            if (!this.passParam) beforePreviewTemplate && beforePreviewTemplate(param, options, (ID) => this.onPreview(true, ID, previewType));
            else this.onPreview(true, '', previewType);
        }
        else if (onExportExcel) {
             this.setState({ loading: true });
            onExportExcel(param, options, true, isPreViewPdfOnly, () => this.setState({ loading: false }));
        }
    }

    onChangeReportTemplate(data) {
        this.passParam = false;
        this.setState({
            reportID: data.ReportID,
            reportName: data.Title,
            url: data.URL,
            report: data,
            fileExt: data.FileExt ? data.FileExt.replace(".", "") : ""
        });
    };

    onPreview = (status = false, ID = '', fileExt) => {
        const objState = this.state?.fileViewerData || {};
        if (ID) objState.urlPreview = fileExt === 'pdf' ? decodeURIComponent(ID) : ID; // decode "pdf" vì FileViewer gắn link vào src
        if (fileExt) objState.fileExt = fileExt;
        this.passParam = true;
        this.setState({ fileViewerData: objState, loading: false, openFileView: status });
    };

    render() {
        const { reportTypeID, hideBtnExcel, hideBtnPdf, btnLoading, isPreview, isViewPDF, FormID} = this.props;
        const { report, reportName, fileExt, openFileView, urlPreview, IsSBJCRM, loading, fileViewerData } = this.state;
        const { reportName: fileViewName = reportName, urlPreview: fileViewUrl = urlPreview, fileExt: fileViewExt = fileExt, } = fileViewerData || {};
        const disabled = !!Object.keys(btnLoading).find(l => btnLoading[l]);
        const isShowPrint = ["W05F2041", "W06F2520", "W07F2020", "W17F2040"].includes(FormID) && IsSBJCRM === 1;
    
        return (
            <Modal
                open
                size={'md'}
                onClose={() => this.onHide()} >
                <ModalHeader>{Config.lang("Chon_mau_bao_cao")}</ModalHeader>
                <ModalBody>
                    <Loading visible={loading} />
                    <Row>
                        <Modal
                            open={openFileView}
                            size={'lg'}
                            onClose={() => this.onPreview(false)} >
                            <ModalHeader title={fileViewName || ' '} />
                            <ModalBody>
                                <FileViewer
                                    isLocalFile={isViewPDF}
                                    fileName={fileViewName}
                                    filePath={fileViewUrl}
                                    fileType={fileViewExt}
                                />
                            </ModalBody>
                        </Modal>
                        <Col xs={12} sm={4}>
                            <Label className={'mgb1x'} required>{Config.lang("Mau_bao_cao")}</Label>
                            <DropDownReportTemplate
                                required={true}
                                modePopUp={true}
                                reportTypeID={reportTypeID}
                                displayExpr={"ReportID"}
                                placeholder={""}
                                onChange={(data) => this.onChangeReportTemplate(data)}>
                            </DropDownReportTemplate>
                        </Col>
                        <Col xs={12} sm={8} verticalAlign={'end'}>
                            <TextBox name={"ReportName"}
                                value={this.state.reportName}
                                disabled={true}
                                className="input-devextreme"
                            >
                            </TextBox>
                        </Col>
                        <Col xs={12}>
                            <div className={'jus-end'}>
                                {isPreview ? (
                                    <>
                                        <ButtonCore
                                            color={'primary'}
                                            viewType={'outlined'}
                                            startIcon={"PaperView"}
                                            label={Config.lang('Preview')}
                                            disabled={disabled || !report}
                                            onClick={() => this.printReport(null, true)}
                                        />
                                        <ButtonCore
                                            color={'primary'}
                                            viewType={'filled'}
                                            startIcon={isShowPrint ? "Download" : "Printer"}
                                            className={'mgl2x'}
                                            label={isShowPrint ? Config.lang("DownLoad") : Config.lang('In1')}
                                            disabled={disabled || !report}
                                            onClick={() => this.printReport()}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {(report?.ReportType === "Word" || !report) &&
                                            <Button isLoading={btnLoading?.word || false}
                                                onClick={() => {
                                                    if (!btnLoading?.word) this.printReport(2)
                                                }}
                                                type={"word"}
                                                disabled={disabled || !report}
                                                className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                name={Config.lang("CRM_Xuat_word")}
                                            />}
                                        {((hideBtnExcel && report?.ReportType === "Excel") || !report) &&
                                            <Button isLoading={btnLoading?.excel || false}
                                                onClick={() => {
                                                    if (!btnLoading?.excel) this.printReport(0)
                                                }}
                                                type={"excel"}
                                                disabled={disabled || !report}
                                                className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                name={Config.lang("CRM_Xuat_Excel")}
                                            />}
                                        {((hideBtnPdf && report?.IsConvertPDF === 1) || !report) &&
                                            <Button className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                onClick={() => {
                                                    if (!btnLoading?.pdf) this.printReport(1)
                                                }}
                                                type={"pdf"}
                                                disabled={disabled || !report}
                                                isLoading={btnLoading?.pdf || false}
                                                name={Config.lang("CRM_Xuat_PDF")}
                                            />}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}

Print.defaultProps = {
    isPreview: false,
    isViewPDF: false,
    FormID: "",
};

Print.propTypes = {
    reportTypeID: PropTypes.string,
    param: PropTypes.array,
    hideBtnExcel: PropTypes.bool,
    hideBtnPdf: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDisabledEXCEL: PropTypes.bool,
    isDisabledPDF: PropTypes.bool,
    onExportExcel: PropTypes.func,
    isPreview: PropTypes.bool,
    beforePreviewTemplate: PropTypes.func,
    isViewPDF: PropTypes.bool,
};
export default connect()(Print);
